<template>
  <div>
    <ToiletCom :bedId="bedId"></ToiletCom>
  </div>
</template>
<script>
import ToiletCom from './../toilet/toiletCom.vue';
export default {
  props: {
    bedId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ToiletCom,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped></style>
